export default __webpack_public_path__ + "static/media/accordianHero.a2febf7d.jpg";